import { Box, CircularProgress, Grid2 as Grid, Typography } from '@mui/material';
import { useWallet } from '@solana/wallet-adapter-react';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setSelectedMenuAction } from '../store/slice';
import NftCardBox from './NFTCardBox';
import { MenuInterface, NftInterface } from './types';

export default function PortfolioContainer() {
    const { connected, publicKey } = useWallet();
    const profile = useSelector((state: any) => state.profile);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(setSelectedMenuAction(MenuInterface.PORTFOLIO));
    }, []);

    useEffect(() => {
        if(connected && publicKey){
            if(profile.pubkey !== publicKey.toBase58()){
                setIsLoading(true);
                return;
            }
        }
        setIsLoading(false);
    }, [connected, publicKey, profile]);

    return (

        <Box pt={2} sx={{width: '100%', flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2}}>
            <Box sx={{width: '100%', maxWidth: 1400, px: 2, mt: 2}}>  
                <Box>
                    <Typography variant="h6" color="primary">Your NFTs:</Typography>
                </Box>
                {isLoading && <Box sx={{width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', pt: 6, height: 100}}>
                    <CircularProgress size="30px"/>
                </Box>}
                {!isLoading && profile?.nfts.length > 0 && <Grid container spacing={{xs: 2, md: 4}} sx={{width: '100%', p: 2}}>
                    {profile?.nfts.map((nft: NftInterface) => (
                        <Grid key={nft.id} size={{xs: 12, sm: 12, md: 6, lg: 4}}>
                            <NftCardBox nft={nft} />
                        </Grid>
                    ))}
                </Grid>}
                {!isLoading && profile?.nfts.length === 0 && <Box sx={{width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                    <Typography variant="h6" color="text.secondary" sx={{pt: 6}}>No NFTs found</Typography>
                </Box>}
            </Box>
        </Box>
    );
}